var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.oidcIsAuthenticated || _vm.$route.meta.isPublic)?_c('div',{staticClass:"h-100",class:[_vm.skinClasses],attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1):_c('div',[_c('session-timeout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }